export { default } from '../../sub/faq';

